import 'swiper/css'
import 'swiper/css/lazy'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { styled } from '@atom-web/core'
import { Box, Column, Row, Stack, Text } from '@atom-web/micros'
import { Star } from '@pyt/icons'
import truncate from 'lodash/truncate'
import Image from 'next/image'
import { lazy } from 'react'
import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import DisplayPrice from '../../../../components/DisplayPrice'
import customImageLoader from '../../../../utils/customImageLoader'
import getImgIXUrl from '../../../../utils/getImgIXUrl'
import redirector from '../../../../utils/redirector'

export const SliderWrapper = styled(Box, {
	display: 'flex',
	'& div.swiper-button-disabled': {
		opacity: 0,
	},
	'.swiper-button-next,.swiper-button-prev ': {
		display: 'none',
	},

	'&.swiper-button-prev': {
		// marginRight: '-50px',
		paddingLeft: '50px',
	},
	'@hover': {
		'&:hover': {
			'& .swiper-button-prev': {
				left: '4px',
			},
			'& .swiper-button-next': {
				right: '4px',
			},
			'& .swiper-button-prev , .swiper-button-next': {
				opacity: 1,
				boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.2)',
				borderRadius: '$round',
				backgroundColor: 'white',
				width: 24,
				height: 24,
				color: '$custom16',
				fontWeight: '$extrabold',
				textAlign: 'center',
				display: 'flex',
				top: '40%',

				'&:after': {
					fontSize: '12px',
				},
			},

			'& .swiper-button-prev, .swiper-button-next': {
				opacity: 1,
			},
			'& .swiper-button-disabled': {
				opacity: 0,
			},
		},
	},

	'& .swiper-pagination-bullet': {
		backgroundColor: '$white',
		height: 6,
		width: 6,
		opacity: 0.5,
		display: 'none',
	},
	'& .swiper-pagination-bullet-active': {
		width: 20,
		height: 6,
		opacity: 1,
		borderRadius: '$pill',
	},
	'& .swiper-slide > span': {
		width: '100% !important',
		height: '100% !important',
	},

	'& .mySwiper > .swiper-wrapper > .swiper-slide': {
		height: 88,
		width: '144px !important',
		opacity: 0.8,
		borderRadius: '$3',
		overflow: 'hidden',
	},
	'& .mySwiper  > .swiper-wrapper > .swiper-slide-thumb-active': {
		opacity: 1,
		border: '4px solid #FFC933',
		borderRadius: '$3',
		height: '96px',
	},
})

export const Slider = ({ displayCurrency, testimonial, resorts }) => {
	if (resorts?.length === 0) {
		return null
	}

	return (
		<SliderWrapper css={{ height: '100%', width: '100%' }}>
			<Swiper
				slidesPerView={1}
				spaceBetween={10}
				breakpoints={{
					375: {
						spaceBetween: 15,
						slidesPerView: 1.2,
					},
					1024: {
						spaceBetween: 10,
						slidesPerView: 3.1,
						slidesPerGroup: 3,
					},
					1280: {
						spaceBetween: 10,
						slidesPerView: 3.5,
						slidesPerGroup: 3,
					},
				}}
				lazy={true}
				navigation={true}
				pagination={{
					clickable: true,
					dynamicBullets: true,
				}}
				modules={[Navigation, Pagination, lazy]}
			>
				{resorts?.map(
					(
						{
							imageURL,
							resortName,
							starRating,
							startsAtPrice,
							hotelSlug,
							numOfBookings,
							nudgeInfo,
						},
						index,
					) => (
						<SwiperSlide key={'flash-deal-' + index} style={{ width: '100%' }}>
							<Column
								gap={3}
								css={{
									cursor: 'pointer',
									width: '270px',
									'@smMax': {
										border: index === 2 ? 0 : '1px solid #d4d4d4',
										borderRadius: '$2',
										// padding: index === 2 && testimonial.reviewLink ? '24px' : 0,
										width: '311px',
										height: '300px',
									},
								}}
								onClick={() =>
									index === 2 && testimonial.reviewLink
										? redirector(testimonial.reviewLink, '__blank')
										: redirector(`/${hotelSlug}`, '__blank')
								}
							>
								{index === 2 && testimonial?.fName ? (
									<>
										<Box
											css={{
												height: '180px',
												width: '280px',
												justifyContent: 'center',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											<Column
												gap={3}
												css={{
													position: 'relative',
													height: '148px',
													width: '148px',
													borderRadius: '100%',
													justifyContent: 'center',
												}}
											>
												<Image
													unoptimized
													objectFit="contain"
													src={
														testimonial.coverImage ||
														'https://pyt-images.imgix.net/images/costing_screen/placeholder/desktop/hotels.png'
													}
													loader={customImageLoader}
													layout="fill"
													className="testimonial-avatar"
												/>
											</Column>
										</Box>
										<Column gap={2} align="center">
											<Column
												css={{
													textAlign: 'center',
												}}
											>
												<Text
													as="p"
													css={{
														fontSize: '15px',
														lineHeight: 1.2,
														letterSpacing: '-.3px',
														color: '#2c2f42',
													}}
												>
													{testimonial?.fName}
												</Text>
												{testimonial?.type && (
													<Text
														css={{
															fontSize: '15px',
															lineHeight: 1.2,
															letterSpacing: '-.3px',
															color: '#aaa',
														}}
													>
														{testimonial?.type} trip
													</Text>
												)}
											</Column>
											<Column align="center" gap={1}>
												{testimonial.shortReview && (
													<Text
														as="p"
														css={{
															fontSize: '16px',
															lineHeight: 1.25,
															letterSpacing: '-.26px',
															color: '#777',
														}}
													>
														{truncate(testimonial.shortReview, {
															length: '26',
														})}
													</Text>
												)}
												{testimonial?.star && (
													<Row>
														{new Array(Math.floor(testimonial.star))
															.fill(null)
															.map((_, key) => (
																<Star
																	fill="#FF2972"
																	key={'star-rating' + key}
																/>
															))}
													</Row>
												)}
											</Column>
										</Column>
									</>
								) : (
									<>
										<Column
											// gap={3}
											css={{
												position: 'relative',
												borderRadius: '3px',
												height: '200px',
												'@lg': {
													width: '270px',
													height: '170px',
												},
											}}
										>
											<Image
												unoptimized
												objectFit="cover"
												src={
													getImgIXUrl(imageURL, 'h=200&w=297&fit=crop') ||
													'https://pyt-images.imgix.net/images/costing_screen/placeholder/desktop/hotels.png'
												}
												loader={customImageLoader}
												layout="fill"
												className="flash-deal"
											/>
										</Column>
										<Column gap={1}>
											<Text
												as="p"
												css={{
													fontSize: '18px',
													fontWeight: '$bolder',
													lineHeight: 1.33,
													letterSpacing: '-.29px',
													textAlign: 'left',
													'@smMax': {
														fontSize: '17px',
														padding: '0 16px 10px',
													},
												}}
											>
												{truncate(resortName, {
													length: '32',
												})}
											</Text>
											<Stack
												gap={1}
												css={{
													alignItems: 'center',

													'@smMax': {
														flexDirection: 'row',
														padding: '0 16px 10px',
													},
												}}
												seperator={
													<Box
														css={{
															width: '$1',
															height: '$1',
															backgroundColor: '#e5e5e5',
															borderRadius: '50%',
														}}
													/>
												}
											>
												<Row gap={1}>
													<Text
														css={{
															fontSize: '13px',
															lineHeight: '16px',
															color: '#444',
														}}
													>
														{starRating}
													</Text>
													<Star fill="#ffc933" />
													<Text
														css={{
															fontSize: '13px',
															lineHeight: '16px',
															color: '#444',
														}}
													>
														hotel
													</Text>
												</Row>
												{numOfBookings ? (
													<Text
														css={{
															fontSize: '13px',
															lineHeight: '16px',
															color: '#444',
														}}
													>
														{numOfBookings} bookings
													</Text>
												) : null}
												{nudgeInfo.highDemand ? (
													<Text
														css={{
															fontSize: '13px',
															lineHeight: '16px',
															color: '#ef435d',
															fontWeight: '$bolder',
														}}
													>
														In high demand
													</Text>
												) : nudgeInfo.googleRating ? (
													<Text
														css={{
															fontSize: '13px',
															lineHeight: '16px',
															color: '#cca129',
														}}
													>
														Rated {nudgeInfo.googleRating} by Google
													</Text>
												) : null}
											</Stack>
											<Row
												gap={1}
												align="center"
												css={{
													'@smMax': {
														padding: '0 16px 10px',
													},
												}}
											>
												<Text
													css={{
														fontSize: '18px',
														lineHeight: '20px',
														color: '#1895b3',
														fontWeight: '$bolder',
													}}
												>
													<DisplayPrice
														objectData={{ value: startsAtPrice }}
														path={'value'}
														defaultValue="0"
														reduxCurrency={displayCurrency}
													/>
												</Text>
												<Text
													css={{
														fontSize: '13px',
														fontWeight: '$bolder',
														lineHeight: '16px',
														color: '#888',
													}}
												>
													for 3 nights
												</Text>
											</Row>
											<Text
												css={{
													fontSize: '13px',
													lineHeight: '16px',
													color: '#888',
													textAlign: 'left',
													'@smMax': {
														padding: '0 16px 10px',
													},
												}}
											>
												Starting price/couple
											</Text>
										</Column>
									</>
								)}
							</Column>
						</SwiperSlide>
					),
				)}
			</Swiper>
		</SliderWrapper>
	)
}
